(() => {
  const initialiseBespokePage = (root) => {
    if (!root || root.dataset.lccBespokeReady === 'true') return;

    root.dataset.lccBespokeReady = 'true';
    root.classList.add('is-enhanced');

    const process = root.querySelector('[data-bespoke-process]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (process) {
      if (reduceMotion || !('IntersectionObserver' in window)) {
        process.classList.add('is-visible');
      } else {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -12% 0px', threshold: 0.14 }
        );

        observer.observe(process);
      }
    }

    const stageSelect = root.querySelector('[data-bespoke-stage-select]');
    root.querySelectorAll('[data-bespoke-stage]').forEach((link) => {
      link.addEventListener('click', () => {
        if (!stageSelect) return;

        const requestedStage = link.dataset.bespokeStage;
        const matchingOption = Array.from(stageSelect.options).find(
          (option) => option.value === requestedStage || option.text === requestedStage
        );

        if (matchingOption) {
          stageSelect.value = matchingOption.value;
          stageSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  };

  document.querySelectorAll('[data-lcc-bespoke]').forEach(initialiseBespokePage);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-lcc-bespoke]');
    initialiseBespokePage(root);
  });
})();
